"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const query_merger_1 = require("./query-merger");
exports.createPageMover = (
/** A base URI of project. */
baseURI, 
/** Next.js built-in router object. */
Router) => (
/** A destination absolute path or return value from `createRoute` function. */
path, 
/**
 * Options.
 * @default {}
 */
options = {}) => {
    var _a, _b;
    const uri = typeof path === "string" ? path : path.href;
    const alias = typeof path === "string" ? path : path.as;
    const res = options.res;
    if (res == undefined) {
        // For client.
        if (options.queryParameters == undefined)
            return Router.push(uri, alias);
        const pageURL = new URL(uri, baseURI);
        const aliasURL = new URL(alias, baseURI);
        const pageQueryString = query_merger_1.mergeQueryString(pageURL, options.queryParameters);
        const aliasQueryString = query_merger_1.mergeQueryString(aliasURL, options.queryParameters);
        return Router.push(`${pageURL.pathname}?${pageQueryString}`, `${aliasURL.pathname}?${aliasQueryString}`);
    }
    // For server.
    const aliasURL = new URL(alias, baseURI);
    const queryString = query_merger_1.mergeQueryString(aliasURL, (_a = options.queryParameters, (_a !== null && _a !== void 0 ? _a : {})));
    const url = new URL(queryString.length > 0 ? `${aliasURL.pathname}?${queryString}` : alias, baseURI);
    res.writeHead((_b = options.statusCode, (_b !== null && _b !== void 0 ? _b : 302)), { Location: url.toString() });
    res.end();
};
